const pocitaniDoDvaceti = () => {
	return [
		{
			id: 1,
			priklad: '20 - 3',
			moznosti: [
				{
					id: 1,
					moznost: '19',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '17',
				},
			],
			vysledek: '17',
		},
		{
			id: 2,
			priklad: '12 + 5',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '17',
				},
			],
			vysledek: '17',
		},
		{
			id: 3,
			priklad: '10 + 6',
			moznosti: [
				{
					id: 1,
					moznost: '19',
				},
				{
					id: 2,
					moznost: '17',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '16',
		},
		{
			id: 4,
			priklad: '20 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '11',
				},
				{
					id: 3,
					moznost: '13',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '11',
		},
		{
			id: 5,
			priklad: '8 + 5',
			moznosti: [
				{
					id: 1,
					moznost: '15',
				},
				{
					id: 2,
					moznost: '13',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '13',
		},
		{
			id: 6,
			priklad: '16 - 6',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '11',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '10',
		},
		{
			id: 7,
			priklad: '19 - 8',
			moznosti: [
				{
					id: 1,
					moznost: '13',
				},
				{
					id: 2,
					moznost: '10',
				},
				{
					id: 3,
					moznost: '12',
				},
				{
					id: 4,
					moznost: '11',
				},
			],
			vysledek: '11',
		},
		{
			id: 8,
			priklad: '0 + 20',
			moznosti: [
				{
					id: 1,
					moznost: '17',
				},
				{
					id: 2,
					moznost: '19',
				},
				{
					id: 3,
					moznost: '20',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '20',
		},
		{
			id: 9,
			priklad: '9 + 9',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '19',
				},
				{
					id: 3,
					moznost: '17',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '18',
		},
		{
			id: 10,
			priklad: '14 - 5',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '7',
				},
			],
			vysledek: '9',
		},
		{
			id: 11,
			priklad: '15 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '6',
		},
		{
			id: 12,
			priklad: '20 - 10',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '11',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '10',
		},
		{
			id: 13,
			priklad: '18 - 5',
			moznosti: [
				{
					id: 1,
					moznost: '13',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '14',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '13',
		},
		{
			id: 14,
			priklad: '17 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '11',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '8',
		},
		{
			id: 15,
			priklad: '20 - 10',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '11',
				},
				{
					id: 4,
					moznost: '10',
				},
			],
			vysledek: '10',
		},
		{
			id: 16,
			priklad: '12 + 2',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '13',
				},
				{
					id: 3,
					moznost: '10',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '14',
		},
		{
			id: 17,
			priklad: '2 + 11',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '13',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '13',
		},
		{
			id: 18,
			priklad: '8 + 6',
			moznosti: [
				{
					id: 1,
					moznost: '14',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '13',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '14',
		},
		{
			id: 19,
			priklad: '3 + 9',
			moznosti: [
				{
					id: 1,
					moznost: '11',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '13',
				},
				{
					id: 4,
					moznost: '14',
				},
			],
			vysledek: '12',
		},
		{
			id: 20,
			priklad: '8 + 8',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '17',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '16',
		},
		{
			id: 21,
			priklad: '13 + 6',
			moznosti: [
				{
					id: 1,
					moznost: '17',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '19',
				},
				{
					id: 4,
					moznost: '16',
				},
			],
			vysledek: '19',
		},
		{
			id: 22,
			priklad: '12 + 8',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '20',
				},
				{
					id: 3,
					moznost: '19',
				},
				{
					id: 4,
					moznost: '17',
				},
			],
			vysledek: '20',
		},
		{
			id: 23,
			priklad: '7 + 7',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '17',
				},
			],
			vysledek: '14',
		},
		{
			id: 24,
			priklad: '5 + 6',
			moznosti: [
				{
					id: 1,
					moznost: '13',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '11',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '11',
		},
	];
};

export default pocitaniDoDvaceti;